// extracted by mini-css-extract-plugin
export var orderDetails = "_r5-2";
export var orderImage = "_r5-1";
export var orderMeta = "_r5-3";
export var orderSummary = "_r5-0";
export var rightArrow = "_r5-4";